module.exports = __webpack_public_path__ + "img/padButton.7effcabf.png";